import { useMutation } from '@tanstack/react-query';
import { createSMSTemplate } from '../../../shared/services';
const useCreateSMSTemplate = () => {
    return useMutation({
        mutationFn: async (data) => await createSMSTemplate(data),
    });
};
export default useCreateSMSTemplate;
